import InputGroup, { type InputGroupProps } from './InputGroup';

export type { InputGroupProps };
export default InputGroup;
